import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { ResponsiveImage } from '../components/ResponsiveImage';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://motoring-daily.onrender.com';

export const ReviewsPage = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCars();
  }, []);

  const fetchCars = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/cars`);
      setCars(data);
    } catch (error) {
      console.error('Error fetching cars:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl font-heading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8F9FA] py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-black mb-4 font-heading">
            Reviews
          </h1>
          <p className="text-lg leading-relaxed text-[#666666]">
            Comprehensive reviews and ratings of the latest vehicles.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {cars.map((car) => (
            <Link
              key={car.id}
              to={`/car/${car.id}`}
              className="bg-white border border-[#E5E7EB] rounded-sm overflow-hidden group hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
              data-testid="car-review-card"
            >
              <div className="relative h-64 overflow-hidden">
                <ResponsiveImage
                  src={car.images[0]}
                  alt={car.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  width={900}
                  quality={72}
                />
                <span className="absolute top-4 left-4 bg-[#00A859] text-white text-xs font-bold uppercase tracking-wider py-1 px-3">
                  Review
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold tracking-tight mb-2 font-heading">
                  {car.name}
                </h3>
                <div className="flex items-center mb-2">
                  <div className="flex items-center mr-2">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className={`w-4 h-4 ${
                          i < Math.floor(car.overall_rating)
                            ? 'text-[#00A859] fill-[#00A859]'
                            : 'text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                  <span className="text-sm text-[#666666]">{car.overall_rating.toFixed(1)}/5</span>
                </div>
                <p className="text-2xl font-black text-[#00A859] mb-4">{car.price}</p>
                <div className="text-sm text-[#666666] space-y-1">
                  <p>{car.year} • {car.fuel_type}</p>
                  <p>{car.transmission} • {car.body_type}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};